module.exports = __webpack_public_path__ + "static/administrativa-a117a749458482fc18f61b28cbad854a.jpg";